/* Complemento de section.settings.sort_sold_out_last.
   Liquid ya deja los agotados al final, pero solo ve la página paginada actual.
   Con pagination_type "load-more" las páginas se apilan en la misma grilla, así
   que los agotados de la página 1 quedan por encima del stock de la página 2.
   Este script reordena tras cada append del load-more y tras cada re-render de
   filtros (Section Rendering API).

   Mueve los nodos reales del DOM en vez de usar CSS order: el orden visual, el
   de tabulación y el de lectores de pantalla quedan alineados (WCAG 1.3.2 y
   2.4.3). Los promo tiles no llevan data-sold-out, así que no se mueven. */
(function () {
  'use strict';

  var SELECTOR = '.products-collection-grid[data-sort-sold-out-last]';

  var initialGrid = document.querySelector(SELECTOR);
  if (!initialGrid) return;
  var section = initialGrid.closest('.shopify-section') || document.body;

  /* Ya está ordenado si ningún elemento en stock aparece después de un agotado */
  function needsReorder(grid) {
    var seenSoldOut = false;
    var children = grid.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].hasAttribute('data-sold-out')) {
        seenSoldOut = true;
      } else if (seenSoldOut) {
        return true;
      }
    }
    return false;
  }

  function reorder(grid) {
    if (!needsReorder(grid)) return;

    var soldOut = [];
    var children = grid.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].hasAttribute('data-sold-out')) soldOut.push(children[i]);
    }

    /* appendChild mueve el nodo existente y conserva el orden relativo entre agotados */
    var fragment = document.createDocumentFragment();
    for (var j = 0; j < soldOut.length; j++) fragment.appendChild(soldOut[j]);
    grid.appendChild(fragment);
  }

  function apply() {
    var grids = section.querySelectorAll(SELECTOR);
    for (var i = 0; i < grids.length; i++) reorder(grids[i]);
  }

  /* Reordenar genera mutaciones que vuelven a disparar el observer, pero la
     siguiente pasada encuentra la grilla ya ordenada y no muta nada, así que
     el ciclo se corta solo. */
  var scheduled = null;
  new MutationObserver(function () {
    clearTimeout(scheduled);
    scheduled = setTimeout(apply, 50);
  }).observe(section, { childList: true, subtree: true });

  apply();
})();
